import React from 'react';
import Loading from './Loading';
import Table from './Table';

const RecentErrors = ({entries}) => {
  if (entries === null) return <Loading />;

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>
      <Table headers={['Date', 'Time', 'Error']}
             contents={entries.map(({ date, time, error }) => {
               return [date, time, error];
             })}
             proportions={[1, 1, 2]} />
    </div>
  );
}

export default RecentErrors;
